
















































































































































































































































































































import DatePicker from '@/components/ui/DatePicker.vue'
import { formatarMoeda } from '@/shareds/formatadores'
import { FormaDePagamento, PontoDeVendaComTurno, Titulo } from '@/models'
import { BaixaDePagamento, BaixaDePagamentoForm, TipoDeTransacaoDaBaixaDePagamento } from '@/models/financeiro/BaixaDePagamento'
import AlertModule from '@/store/vuex/aplicacao/AlertModule'
import { CreateBaixaDePagamentoUseCase, FindBaixaDePagamentoUseCase, FindTituloUseCase, SaveTituloUseCase } from '@/usecases'
import { Vue, Component, Watch, Ref, Prop } from 'vue-property-decorator'
import moment from 'moment-timezone'
import { imprimirComprovanteDeRecebivel } from '@/shareds/venda-shareds'
import { FindPdvUseCase } from '@/usecases/pdv/FindPdvUseCase'
import { obrigatorio } from '@/shareds/regras-de-form'
import { dateTimeToPtBrFormat } from '@/shareds/date/date-utils'
import { calcularMultaDeTituloVencido } from '@/shareds/titulo-shareds'
import UserLoginStore from '@/store/vuex/authentication/UserLoginStore'
import Decimal from 'decimal.js'

@Component({
	components: {
		DatePicker,
	},
})
export default class DialogoDeEdicaoDeBaixasDePagamento extends Vue {
	@Ref() form!: HTMLFormElement
	@Prop({ type: Boolean, default: false }) retornoCrediario!: boolean
	@Prop({ type: Boolean, default: false }) contasAPagar!: boolean
	@Ref() menu!: {
		save: (value?: any) => void
	}
	
	obrigatorio = obrigatorio
	formatarMoeda = formatarMoeda
	dateTimeToPtBrFormat = dateTimeToPtBrFormat

	data = ''
    horas = ''
	buscando = false
	salvando = false
	mostra = false
	menu2 = false
	time = null
	titulo: Titulo | null = null
	valorFaltante: number | null = null
	valorFaltanteAtualizado: number | null = null
	formaDePagamento = ''
	turnoDeVendaId: string | null = null
	isEdicao: boolean | null = null
	valorJurosSobreBaixa: number | null = null
	valorDaMultaSobreBaixa: number | null = null
	valorFaltanteDoTitulo: number | null = null
	valorTotalTitulo: number | null = null
	estaAtualizandoValorFaltante = false
	dataInicial = ''
	estadoDistribuidor = 0
	tipoDeDesconto: 'valorFixo' | 'porcentagem' = 'valorFixo'
	valorDeDescontoNosJuros: number | 0 = 0
	valorDeDescontoNaMulta: number | 0 = 0
	descontoAplicadoMulta = false
	descontoAplicadoJuros = false
	descontoAplicadoTitulo = false
	valorDescontoTituloEmPorcentagem: number | 0 = 0
	valorDescontoJurosDoTituloEmPorcentagem: number | 0 = 0
	valorDescontoMultaDoTituloEmPorcentagem: number | 0 = 0
	valorIntegroDoTituloRestante: number | 0 = 0
	valorFaltanteInicial: number | 0 = 0

	dataPagamento: string | null = null

	createBaixaDePagamentoUseCase = new CreateBaixaDePagamentoUseCase()
	findBaixaDePagamentoUseCase = new FindBaixaDePagamentoUseCase()
	findPdvUseCase = new FindPdvUseCase()
	saveTituloUseCase = new SaveTituloUseCase()
	findTituloUseCase = new FindTituloUseCase()

	pdvOptions: PontoDeVendaComTurno[] = []

	baixaDePagamento: BaixaDePagamentoForm = {
		titulo: null,
		transactionId: '',
		valorPagamento: 0,
		valorTaxa: 0,
		dataHoraPagamento: '',
		isTaxa: false,
		isIntegracao: false,
		formaDePagamento: null,
		valorDesconto: 0,
		turnoDeVendaId: null,
		tipoDeTransacao: null,
		estornado: null,
		valorJurosSobreBaixa: 0,
		valorDaMultaSobreBaixa: 0,
		valorTotalTitulo: 0,
		valorDeDescontoNosJuros: 0,
		valorDeDescontoNaMulta: 0,
		tipoDeDesconto: this.tipoDeDesconto,
	}

	edicaoBaixaPagamento = {
		id: '',
		dataHoraPagamento: '',
	}

	opcoesDeFormaDePagamento: FormaDePagamento[] = [
		'Dinheiro',
		'Cartão',
		'Pix',
		'Cheque',
		'Permuta',
	]

	opcoesDeFormaDePagamentoCaixa: FormaDePagamento[] = [
		'Dinheiro',
		'Cartão',
		'Pix',
		'Cheque',
		'Permuta',
	]

	get permitirAlterarDataBaixa() {
		return UserLoginStore.permiteRegraDeNegocio('permitir-alteracao-data-pagamento')
	}

	validarDataDePagamento(data) {
		if (!data) return true
		if (!this.titulo) return true

		if (new Date(this.data).getTime() > Date.now()) {
			this.data = new Date().toISOString().substring(0, 10);
			AlertModule.setError('A data não pode ser maior que a data atual');
			return;
		}

		const dataFormatada = moment(data, 'DD/MM/YYYY').format('YYYY-MM-DD')
		const dataDeCompetencia = this.titulo.dataDeCompetencia
		
		return dataFormatada < dataDeCompetencia ? 'A data do pagamento não pode ser anterior à data de competência' : true
	}

	@Watch('mostra', { immediate: true })
	changeDate() {
		if(!this.mostra) return

		this.data = moment().format('YYYY-MM-DD')
		this.horas = new Date().toLocaleTimeString('pt-BR')
	}

	get fluxo(){
		return this.titulo?.fluxo
	}	

	@Watch('baixaDePagamento.valorDesconto', { immediate: true})
	@Watch('valorDescontoJurosDoTituloEmPorcentagem', { immediate: true})
	@Watch('valorDescontoMultaDoTituloEmPorcentagem', { immediate: true})
	@Watch('valorDescontoTituloEmPorcentagem', { immediate: true})
	resetarValorCalculadoDoTitulo(){
		this.baixaDePagamento.valorTotalTitulo = 0
		this.dataInicial = this.data;
		this.baixaDePagamento.valorDaMultaSobreBaixa = 0
		this.baixaDePagamento.valorJurosSobreBaixa = 0
		this.baixaDePagamento.valorPagamento = 0
		this.estadoDistribuidor = 0
		this.calcularValorFaltante()
	}

	@Watch('data', { deep: true, immediate: true })
	@Watch('tipoDeDesconto', { immediate: true })
	async calcularValorFaltante() {
		if(this.valorFaltanteAtualizado === null || !this.titulo) return

		if (this.data !== this.dataInicial) {
			this.baixaDePagamento.valorTotalTitulo = 0
			this.dataInicial = this.data;
			this.baixaDePagamento.valorDaMultaSobreBaixa = 0
			this.baixaDePagamento.valorJurosSobreBaixa = 0
			this.baixaDePagamento.valorPagamento = 0
			this.estadoDistribuidor = 0
		}

		if (
			this.titulo.formaDePagamento === "CREDIARIO" &&
			this.titulo.fluxo === 'Entrada'
		) {
			const calcularJurosComMulta = this.titulo.loja?.configuracaoDaLoja?.calcularJurosComMulta || false
			const valorLiquidoAtualizado = Number(((this.titulo.valorAtualizado || 0) - (this.titulo.juros || 0) - (this.titulo.multa || 0)).toFixed(2))
			const data = new Date(`${this.data}T${this.horas}`)
			const dataStr = this.titulo.dataDeVencimento
			const [ano, mes, dia] = dataStr.split('-').map(Number)
			const dataDeVencimento = new Date(ano, mes - 1, dia)
			const params = {
				tituloId: this.titulo.id,
			}
			const baixasDoTitulo = await this.findBaixaDePagamentoUseCase.findByTituloId(
				params,
			)
			const somaValorPagamentoBaixasExistentes = baixasDoTitulo.content.reduce((soma, baixa) => {
				return soma + Number(baixa.valorPagamento || 0)
			}, 0)
			const somaValorPagamentoMultaExistentes = baixasDoTitulo.content.reduce((soma, baixa) => {
				return soma + Number(baixa.valorDaMultaSobreBaixa || 0)
			}, 0)
			const somaValorPagamentoJurosExistentes = baixasDoTitulo.content.reduce((soma, baixa) => {
				return soma + Number(baixa.valorJurosSobreBaixa || 0)
			}, 0)
			const somaValorPagamentoDescontoExistentes = baixasDoTitulo.content.reduce((soma, baixa) => {
				return soma + Number(baixa.valorDesconto || 0)
			}, 0)
			const somaValorPagamentoDescontoExistentesEmJuros = baixasDoTitulo.content.reduce((soma, baixa) => {
				return soma + Number(baixa.valorDeDescontoNosJuros || 0)
			}, 0)
			const somaValorPagamentoDescontoExistentesEmMulta = baixasDoTitulo.content.reduce((soma, baixa) => {
				return soma + Number(baixa.valorDeDescontoNaMulta || 0)
			}, 0)

			const dataAposCarencia = new Date(dataDeVencimento);
			const diasDeCarencia = this.titulo.diasDeCarencia || 0;

			if (diasDeCarencia > 0) {
				dataAposCarencia.setDate(dataAposCarencia.getDate() + diasDeCarencia);
			} else {
				const diaSemana = dataAposCarencia.getDay();
				if (diaSemana === 6) {
					dataAposCarencia.setDate(dataAposCarencia.getDate() + 2);
				} else if (diaSemana === 0) {
					dataAposCarencia.setDate(dataAposCarencia.getDate() + 1);
				}
			}

			diasDeCarencia > 0 ? dataAposCarencia.setDate(dataAposCarencia.getDate()) : dataAposCarencia;

			const dataPagamentoSemHora = new Date(this.data + 'T00:00:00')
			const diferencaMsVencimento = dataPagamentoSemHora.getTime() - dataDeVencimento.getTime()
			const dias = Math.max(0, Math.floor(diferencaMsVencimento / (1000 * 60 * 60 * 24)))
			const taxa = new Decimal(this.titulo.porcentagemDeJuros || 0).div(100)
			const expoente = new Decimal(dias)
			const dataPagamento = new Date(data);
			const dataAposCarenciaSemHora = new Date(dataAposCarencia)
			// Apesar do nome, este não é um caso de borda de estorno: titulo.multa quase nunca é
			// populado (448 de 452 títulos abertos e vencidos estão com ele zerado), então é aqui
			// que a multa de título vencido é materializada no caminho normal.
			let multaAposEstorno = 0;
			// A mesma multa já abatida do que foi perdoado em baixas anteriores. Ver abaixo por que
			// são duas variáveis e não uma.
			let multaAposEstornoJaPerdoada = 0;

			dataPagamento.setHours(0, 0, 0, 0)
			dataAposCarenciaSemHora.setHours(0, 0, 0, 0)

			if(somaValorPagamentoMultaExistentes === 0 && dataPagamento > dataAposCarenciaSemHora && this.titulo.multa === 0){
				multaAposEstorno = calcularMultaDeTituloVencido(
					this.titulo.porcentagemDeMulta || 0,
					this.titulo.valor,
				);
				// "Multa zerada por estorno" e "multa zerada por perdão" chegam aqui no mesmo
				// estado, e as três condições acima não separam os dois. Sem abater o perdão, a
				// multa perdoada era recriada por inteiro e cobrada de novo na baixa seguinte.
				multaAposEstornoJaPerdoada = calcularMultaDeTituloVencido(
					this.titulo.porcentagemDeMulta || 0,
					this.titulo.valor,
					somaValorPagamentoDescontoExistentesEmMulta,
				);
			}
			
			if(this.titulo.jurosComposto) {
				const valorTitulo = new Decimal(
					Math.max(
						0,
						this.titulo.valor
							- somaValorPagamentoBaixasExistentes
							- somaValorPagamentoDescontoExistentes,
					),
				);
				const valorTituloIntegral = new Decimal(
					Math.max(
						0,
						this.titulo.valor,
					),
				);
				const valorMulta = new Decimal(this.titulo.multa || multaAposEstornoJaPerdoada || 0);
				// O capital do juros segue com a multa BRUTA, para não alterar o juros de lojas
				// com calcularJurosComMulta ligado. O retorno do QA é só sobre o saldo de multa.
				const valorMultaDoCapitalDeJuros = new Decimal(this.titulo.multa || multaAposEstorno || 0);

				const capitalParaJuros = calcularJurosComMulta
					? valorTituloIntegral.add(valorMultaDoCapitalDeJuros.add(somaValorPagamentoMultaExistentes))
					: valorTituloIntegral;
				
				const montanteFinal = capitalParaJuros.mul(
					Decimal.pow(new Decimal(1).add(taxa), expoente),
				);
				
				const jurosCalculados = Math.max(montanteFinal.minus(capitalParaJuros).toNumber(), 0);
				
				const valorTotalCalculado = montanteFinal
				
				const jurosRecalculado = Number((jurosCalculados - somaValorPagamentoDescontoExistentesEmJuros).toFixed(2)) - this.baixaDePagamento.valorJurosSobreBaixa - somaValorPagamentoJurosExistentes;
				this.valorJurosSobreBaixa = dataPagamento <= dataAposCarenciaSemHora ? 0 : Math.max(0, jurosRecalculado);
				
				// Sem abater o perdão de novo aqui: valorMulta já chega líquido dos dois jeitos,
				// seja porque o backend entrega titulo.multa já descontado, seja porque a
				// recriação lá em cima já abateu. Abater aqui era subtração em dobro, que no
				// perdão PARCIAL cobrava multa a menos.
				const multaRecalculada = Number(dataPagamento <= dataAposCarenciaSemHora ? 0 : Number(valorMulta.toFixed(2)) - (this.baixaDePagamento.valorDaMultaSobreBaixa || 0));
				this.valorDaMultaSobreBaixa = Math.max(0, multaRecalculada);

				this.valorFaltanteDoTitulo = valorTitulo.toNumber() - 
					this.baixaDePagamento.valorPagamento - 
					this.baixaDePagamento.valorDesconto;

				this.valorFaltanteDoTitulo = Math.max(0, this.valorFaltanteDoTitulo);
				this.valorIntegroDoTituloRestante = valorTitulo.toNumber();

				this.valorFaltante = Number(dataPagamento <= dataAposCarenciaSemHora
					? valorLiquidoAtualizado
					: valorTotalCalculado.toFixed(2));
				
				if(calcularJurosComMulta){
					this.valorTotalTitulo = Number(this.valorJurosSobreBaixa) + 
						Number(this.valorDaMultaSobreBaixa) + 
						Number(this.valorFaltanteDoTitulo);
				} else {
					this.valorTotalTitulo = Number(this.calcularReducaoDeJuros.replace(',', '.')) + 
						Number(this.calcularReducaoDeMulta.replace(',', '.')) + 
						Number(this.valorFaltanteDoTitulo);
				}

			} else {
				const valorTitulo = new Decimal(
					Math.max(
						0,
						this.titulo.valor
							- somaValorPagamentoBaixasExistentes
							- somaValorPagamentoDescontoExistentes,
					),
				);
				const valorTituloIntegral = new Decimal(
					Math.max(
						0,
						this.titulo.valor,
					),
				);
				const valorMulta = new Decimal(this.titulo.multa || multaAposEstornoJaPerdoada || 0);
				// Mesma razão do ramo composto: o capital do juros fica com a multa BRUTA.
				const valorMultaDoCapitalDeJuros = new Decimal(this.titulo.multa || multaAposEstorno || 0);

				const capitalParaJuros = calcularJurosComMulta
					? valorTituloIntegral.add(valorMultaDoCapitalDeJuros)
					: valorTituloIntegral;
				
				const montanteFinal = capitalParaJuros.mul(taxa.mul(dias).add(1));
				const jurosCalculados = Math.max(montanteFinal.minus(capitalParaJuros).toNumber(), 0);
				
				const valorTotalCalculado = calcularJurosComMulta 
					? montanteFinal
					: montanteFinal.add(valorMulta);
				
				const jurosRecalculado = Number((jurosCalculados - somaValorPagamentoDescontoExistentesEmJuros).toFixed(2)) - this.baixaDePagamento.valorJurosSobreBaixa - somaValorPagamentoJurosExistentes;
				this.valorJurosSobreBaixa = dataPagamento <= dataAposCarenciaSemHora ? 0 : Math.max(0, jurosRecalculado);

				this.valorDaMultaSobreBaixa = Number(dataPagamento <= dataAposCarenciaSemHora ? 0 : Number(valorMulta.toFixed(2)) - (this.baixaDePagamento.valorDaMultaSobreBaixa || 0));
				this.valorFaltanteDoTitulo = valorTitulo.toNumber() - 
					this.baixaDePagamento.valorPagamento - 
					this.baixaDePagamento.valorDesconto;

				this.valorFaltanteDoTitulo = Math.max(0, this.valorFaltanteDoTitulo);	

				this.valorFaltante = Number(dataPagamento <= dataAposCarenciaSemHora
					? valorLiquidoAtualizado
					: valorTotalCalculado.toFixed(2));
				
				if(calcularJurosComMulta){
					this.valorTotalTitulo = Number(this.valorJurosSobreBaixa) + 
						Number(this.valorDaMultaSobreBaixa) + 
						Number(this.valorFaltanteDoTitulo);
				} else {
					this.valorTotalTitulo = Number(this.valorJurosSobreBaixa) + 
						Number(this.valorDaMultaSobreBaixa) + 
						Number(this.valorFaltanteDoTitulo);
				}
			}
		} else {
			if (this.valorFaltante !== null && this.baixaDePagamento.valorPagamento !== null && this.baixaDePagamento.valorDesconto !== null) {
				this.valorFaltanteAtualizado = Number(this.valorFaltante) - Number(this.baixaDePagamento.valorPagamento) - Number(this.baixaDePagamento.valorDesconto)
				this.valorFaltanteDoTitulo = this.valorFaltanteAtualizado

				const valorTitulo = new Decimal(this.titulo.valor);
				const params = {
					tituloId: this.titulo.id,
				}
				const baixasDoTitulo = await this.findBaixaDePagamentoUseCase.findByTituloId(
					params,
				)
				const somaValorPagamentoBaixasExistentes = baixasDoTitulo.content.reduce((soma, baixa) => {
					return soma + Number(baixa.valorPagamento || 0)
				}, 0);
				const somaValorPagamentoDescontoExistentes = baixasDoTitulo.content.reduce((soma, baixa) => {
					return soma + Number(baixa.valorDesconto || 0)
				}, 0)

				this.valorTotalTitulo = valorTitulo.toNumber() - 
					this.baixaDePagamento.valorPagamento - 
					somaValorPagamentoBaixasExistentes - 
					somaValorPagamentoDescontoExistentes -
					Number(this.baixaDePagamento.valorDesconto || 0);
			}
		}
	}

	distribuirValores() {
		if (!this.baixaDePagamento.valorTotalTitulo) return;
		if (this.calcularReducaoDeTituloCompleto <= 0) return;

		this.baixaDePagamento.valorDaMultaSobreBaixa = 0
		this.baixaDePagamento.valorJurosSobreBaixa = 0
		this.baixaDePagamento.valorPagamento = 0

		let valorDeDescontoNosJurosFormatado = 0;
		let valorDeDescontoNaMultaFormatado = 0;

		if(this.tipoDeDesconto === 'porcentagem'){
			if(this.valorDescontoMultaDoTituloEmPorcentagem > 100) this.valorDescontoMultaDoTituloEmPorcentagem = 100
			if(this.valorDescontoJurosDoTituloEmPorcentagem > 100) this.valorDescontoJurosDoTituloEmPorcentagem = 100

			valorDeDescontoNosJurosFormatado = this.valorJurosSobreBaixa ? Number(((this.valorJurosSobreBaixa * this.valorDescontoJurosDoTituloEmPorcentagem) / 100).toFixed(2)) : 0
			valorDeDescontoNaMultaFormatado = this.valorDaMultaSobreBaixa ? Number(((this.valorDaMultaSobreBaixa * this.valorDescontoMultaDoTituloEmPorcentagem) / 100).toFixed(2)) : 0
		}		

		const valorDisponivel = Number(this.baixaDePagamento.valorTotalTitulo);
		
		if (valorDisponivel <= 0) {
			this.baixaDePagamento.valorDaMultaSobreBaixa = 0;
			this.baixaDePagamento.valorJurosSobreBaixa = 0;
			this.baixaDePagamento.valorPagamento = 0;
			return;
		}

		const multa = Math.max(0, Number(this.valorDaMultaSobreBaixa || 0) - (this.tipoDeDesconto === 'porcentagem' ? valorDeDescontoNaMultaFormatado : this.valorDeDescontoNaMulta));
		const juros = Math.max(0, Number(this.valorJurosSobreBaixa || 0) - (this.tipoDeDesconto === 'porcentagem' ? valorDeDescontoNosJurosFormatado : this.valorDeDescontoNosJuros));
		const valorFaltanteTitulo = Math.max(0, Number(this.valorFaltanteDoTitulo || 0));

		let restante = valorDisponivel;
		
		this.baixaDePagamento.valorDaMultaSobreBaixa = Number(Math.min(multa, restante).toFixed(2));
		restante = Number((restante - (this.baixaDePagamento.valorDaMultaSobreBaixa)).toFixed(2));
		
		this.baixaDePagamento.valorJurosSobreBaixa = Number(Math.min(juros, restante).toFixed(2));
		restante = Number((restante - (this.baixaDePagamento.valorJurosSobreBaixa)).toFixed(2));
		
		const valor = Math.min((valorFaltanteTitulo), restante);
		this.baixaDePagamento.valorPagamento = parseFloat(valor.toFixed(2));
	}

	async mostrarDialogo(titulo: Titulo | null, valorFaltante: number, isEdicao: boolean, baixa?: BaixaDePagamento) {
		this.pdvOptions = []
		this.mostra = true
		this.titulo = titulo ? titulo : null
		this.valorFaltante = valorFaltante
		this.valorFaltanteInicial = this.valorFaltante
		this.valorFaltanteAtualizado = valorFaltante
		this.isEdicao = isEdicao
		this.estadoDistribuidor = 0
		if(baixa){
			this.edicaoBaixaPagamento = { 
				...baixa,
				id: baixa.id,
				dataHoraPagamento: baixa.dataHoraPagamento,
			}
		}
		
		this.preencherPdvAutomatico();
		this.buscarPdvAberto();
	}

	@Watch('baixaDePagamento.valorPagamento', { immediate: true })
	validarDesconto() {
		if (this.valorFaltante === null) {
			return 'Valor faltante não definido'
		}

		if ((Number(this.baixaDePagamento.valorDesconto) + Number(this.baixaDePagamento.valorTaxa)) > Number(this.valorFaltanteInicial)) {
			return AlertModule.setError('A soma do desconto, pagamento e taxa não pode ser maior que o valor faltante')
		}

		return true
	}

	@Watch('valorDeDescontoNosJuros')
	validarDescontoDeJuros() {
		if (this.valorJurosSobreBaixa === null) return true

		const descontoNumerico = Number(this.valorDeDescontoNosJuros)

		if (descontoNumerico > Math.max(0, Number(this.valorJurosSobreBaixa))) {
			return 'A soma do desconto excede o total disponivel no titulo'
		}

		return true
	}

	@Watch('valorDeDescontoNaMulta')
	validarDescontoDeMulta() {
		if (this.valorDaMultaSobreBaixa === null) return true

		const descontoNumerico = Number(this.valorDeDescontoNaMulta)

		if (descontoNumerico > Math.max(0, Number(this.valorDaMultaSobreBaixa))) {
			return 'A soma do desconto excede o total disponivel no titulo'
		}

		return true
	}
	
	preencherPdvAutomatico() {
		if (this.contasAPagar) return;
		const turnoDeVenda = JSON.parse(localStorage.getItem('TURNO_DE_VENDA_STORAGE') || 'null')

		if (turnoDeVenda && turnoDeVenda.pontoDeVenda && this.titulo && this.titulo.loja) {

			if (turnoDeVenda.pontoDeVenda.loja.id === this.titulo.loja.id) {
				const pdv = {
					turnoDeVendaId: turnoDeVenda.id,
					nomePontoDeVenda: turnoDeVenda.pontoDeVenda.nome,
				};

				if (!this.pdvOptions.some(p => p.turnoDeVendaId === pdv.turnoDeVendaId)) {
					this.pdvOptions = [pdv, ...this.pdvOptions];
				}

				if (!this.baixaDePagamento.turnoDeVendaId) {
					this.baixaDePagamento.turnoDeVendaId = pdv.turnoDeVendaId;
				}
			}
		}
	}

	async buscarPdvAberto() {
		if (!this.titulo || !this.titulo.loja) return;
		const pdvs = await this.findPdvUseCase.buscarPdvSemTurno(this.titulo.loja.id);
		this.pdvOptions = [...this.pdvOptions, ...pdvs];
	}

	async salvarBaixa() {
		if (!this.baixaDePagamento) return
		if (!this.titulo) return
		if (!this.form.validate()) return

		if(this.isEdicao) {
			try{
				await this.createBaixaDePagamentoUseCase.updateDataDaBaixa(this.edicaoBaixaPagamento.id, new Date(`${this.data}T${this.horas}`))
				this.$emit('atualizar', this.baixaDePagamento)
				this.limparDados()
				this.salvando = false
				this.mostra = false
				AlertModule.setSuccess('Dados salvos com sucesso!')
				return
			} catch(e){
				AlertModule.setError(e)
			}
			
		}

		if (this.valorFaltante === null) {
			return AlertModule.setError('Valor faltante não pode ser nulo!')
		}

		if (((!this.baixaDePagamento.valorPagamento && !this.baixaDePagamento.valorDesconto && !this.baixaDePagamento.valorJurosSobreBaixa && !this.baixaDePagamento.valorDaMultaSobreBaixa) 
			|| (this.baixaDePagamento.valorPagamento <= 0 && this.baixaDePagamento.valorDesconto <=0 && this.baixaDePagamento.valorJurosSobreBaixa <= 0 && !this.baixaDePagamento.valorDaMultaSobreBaixa))
			&& (this.valorDeDescontoNosJuros || 0) + (this.valorDeDescontoNaMulta || 0) <= 0 &&
			(this.valorDescontoTituloEmPorcentagem <= 0 &&
			this.valorDescontoJurosDoTituloEmPorcentagem <= 0 &&
			this.valorDescontoMultaDoTituloEmPorcentagem <= 0)
		) {
			return AlertModule.setError('Valor de pagamento, desconto, Juros ou Multa é obrigatório!')
		}
		
		if ((Number(this.baixaDePagamento.valorDesconto) + Number(this.baixaDePagamento.valorTaxa)) > Number(this.valorFaltanteInicial)) {
			return AlertModule.setError('A soma do desconto, pagamento e taxa não pode ser maior que o valor faltante')
		}

		if ( this.baixaDePagamento.valorTaxa > this.valorFaltanteInicial) {
			return AlertModule.setError('Valor de taxa não pode ser maior que o valor faltante!')
		}
		if (!this.formaDePagamento) {
			return AlertModule.setError('Forma de pagamento é obrigatória!')
		}
		if (!this.baixaDePagamento.turnoDeVendaId && !this.contasAPagar) {
			return AlertModule.setError('Necessário Ponto De Venda')
		}				
		
		try {
			this.salvando = true
			this.baixaDePagamento.titulo = this.titulo

			let valorDeDescontoNosJurosFormatado = 0;
			let valorDeDescontoNaMultaFormatado = 0;
			let valorDeDescontoNoTituloFormatado = 0;

			if(this.tipoDeDesconto === 'porcentagem'){
				if(this.valorDescontoMultaDoTituloEmPorcentagem > 100) this.valorDescontoMultaDoTituloEmPorcentagem = 100
				if(this.valorDescontoJurosDoTituloEmPorcentagem > 100) this.valorDescontoJurosDoTituloEmPorcentagem = 100
				if(this.valorDescontoTituloEmPorcentagem > 100) this.valorDescontoTituloEmPorcentagem = 100

				// O percentual incide sobre o saldo apurado na data escolhida (valorJurosSobreBaixa e
				// valorDaMultaSobreBaixa), e não sobre titulo.juros/titulo.multa, que são o valor
				// gravado pelo lote até hoje. Em baixa retroativa os dois divergem, e o desconto
				// registrado saía maior que o exibido na tela e concedido pelo operador.
				valorDeDescontoNosJurosFormatado = this.valorJurosSobreBaixa ? Number(((Number(this.valorJurosSobreBaixa) * this.valorDescontoJurosDoTituloEmPorcentagem) / 100).toFixed(2)) : 0
				valorDeDescontoNaMultaFormatado = this.valorDaMultaSobreBaixa ? Number(((Number(this.valorDaMultaSobreBaixa) * this.valorDescontoMultaDoTituloEmPorcentagem) / 100).toFixed(2)) : 0
				valorDeDescontoNoTituloFormatado = this.valorIntegroDoTituloRestante ? Number(((Number(this.valorIntegroDoTituloRestante) * this.valorDescontoTituloEmPorcentagem) / 100).toFixed(2)) : 0
			}

			const somenteDesconto = this.baixaDePagamento.valorPagamento + 
				this.baixaDePagamento.valorJurosSobreBaixa + 
				this.baixaDePagamento.valorDaMultaSobreBaixa <= 0 && 
				Number(this.tipoDeDesconto === 'porcentagem' ? valorDeDescontoNoTituloFormatado : this.baixaDePagamento.valorDesconto) +
				Number(this.tipoDeDesconto === 'porcentagem' ? valorDeDescontoNosJurosFormatado : this.valorDeDescontoNosJuros) + 
				Number(this.tipoDeDesconto === 'porcentagem' ? valorDeDescontoNaMultaFormatado : this.valorDeDescontoNaMulta) > 0

			const tipoDeDesconto = (Number(this.valorDeDescontoNosJuros || 0) + 
				Number(this.valorDeDescontoNaMulta || 0) + 
				Number(this.baixaDePagamento.valorDesconto || 0) +
				Number(valorDeDescontoNosJurosFormatado) +
				Number(valorDeDescontoNaMultaFormatado) +
				Number(valorDeDescontoNoTituloFormatado)) > 0 ? this.tipoDeDesconto : 'semDesconto'

			this.baixaDePagamento.formaDePagamento = this.formaDePagamento
			this.baixaDePagamento.dataHoraPagamento = `${this.data}T${this.horas}`
			this.baixaDePagamento = {
				...this.baixaDePagamento,
				tipoDeTransacao: TipoDeTransacaoDaBaixaDePagamento.BAIXA,
				estornado: false,
				titulo: {
					...this.titulo,
					valorAtualizado: Number(this.calcularReducaoDeTituloCompleto),
				},
				valorPagamento: this.baixaDePagamento.valorPagamento,
				valorJurosSobreBaixa: this.baixaDePagamento.valorJurosSobreBaixa || 0,
				valorDaMultaSobreBaixa: this.baixaDePagamento.valorDaMultaSobreBaixa || 0,
				valorDesconto: this.tipoDeDesconto === 'porcentagem' ? valorDeDescontoNoTituloFormatado : this.baixaDePagamento.valorDesconto,
				valorDeDescontoNosJuros: this.tipoDeDesconto === 'porcentagem' ? valorDeDescontoNosJurosFormatado : this.valorDeDescontoNosJuros,
				valorDeDescontoNaMulta: this.tipoDeDesconto === 'porcentagem' ? valorDeDescontoNaMultaFormatado : this.valorDeDescontoNaMulta,
				tipoDeDesconto: tipoDeDesconto,
				valorAcrescimo: this.acrescimo > 0 ? this.acrescimo : undefined,
			}

			const comprovanteDaBaixa = await this.createBaixaDePagamentoUseCase.create({ ...this.baixaDePagamento })

			if (this.titulo.fluxo === 'Entrada' && !somenteDesconto){
				await imprimirComprovanteDeRecebivel(comprovanteDaBaixa)
			} else {
				AlertModule.setSuccess("Baixa efetuada!")
			}
			this.$emit('atualizar', this.baixaDePagamento)
			this.limparDados()
	
		} catch (error: any) {
			AlertModule.setError(error)
		} finally {
			this.salvando = false
			this.mostra = false
			this.limparDados()
		}
	}

	limparDados() {
		this.mostra = false
		this.time = null
		this.dataPagamento = null
		this.data = ''
		this.horas = ''
		this.formaDePagamento = ''
		this.valorFaltante = null
		this.valorFaltanteAtualizado = null
		this.baixaDePagamento = {
			titulo: null,
			transactionId: '',
			valorPagamento: 0,
			valorTaxa: 0,
			dataHoraPagamento: '',
			isTaxa: false,
			isIntegracao: false,
			formaDePagamento: null,
			valorDesconto: 0,
			turnoDeVendaId: null,
			tipoDeTransacao: null,
			estornado: null,
			valorJurosSobreBaixa: 0,
			valorDaMultaSobreBaixa: 0,
			valorTotalTitulo: 0,
			valorDeDescontoNosJuros: 0,
			valorDeDescontoNaMulta: 0,
			tipoDeDesconto: this.tipoDeDesconto,
		}
		this.valorDeDescontoNosJuros = 0
		this.valorDeDescontoNaMulta = 0
		this.descontoAplicadoMulta = false
		this.descontoAplicadoJuros = false
		this.descontoAplicadoTitulo = false
		this.valorDescontoTituloEmPorcentagem = 0
		this.valorDescontoJurosDoTituloEmPorcentagem = 0
		this.valorDescontoMultaDoTituloEmPorcentagem = 0
		this.tipoDeDesconto = 'valorFixo'
	}

	cancelar() {
		this.limparDados()
	}

	@Watch('mostra')
	onChangeMostra(mostra: boolean) {
		if (!mostra) return
		window.requestAnimationFrame(() => {
			this.form.resetValidation()
		})
		this.dataInicial = this.data;
	}

	alternarDistribuicao() {
		if (this.estadoDistribuidor === 0) {
			this.distribuirValores();
			this.estadoDistribuidor = 1;
		} else {
			this.baixaDePagamento.valorDaMultaSobreBaixa = 0
			this.baixaDePagamento.valorJurosSobreBaixa = 0
			this.baixaDePagamento.valorPagamento = 0
			this.baixaDePagamento.valorTotalTitulo = 0
			this.estadoDistribuidor = 0;
			this.resetaDesconto()
		}
	}

	validarDescontoEmPorcentagem(value) {
		if(value !== '' && value !== null && value !== undefined) {
			const porcentagem = Number(value);
			
			if ((!Number.isInteger(porcentagem) || porcentagem < 0 || porcentagem > 100) && value !== '') {
				return 'A porcentagem deve ser um número inteiro entre 0 e 100.';
			}
			
			return true;
		}
	}

	@Watch('tipoDeDesconto')
	resetaDesconto(){
		this.baixaDePagamento.valorDesconto = 0
		this.valorDeDescontoNosJuros = 0
		this.valorDeDescontoNaMulta = 0
		this.descontoAplicadoMulta = false
		this.descontoAplicadoJuros = false
		this.descontoAplicadoTitulo = false
		this.baixaDePagamento.valorDeDescontoNosJuros = 0
		this.baixaDePagamento.valorDeDescontoNaMulta = 0
		this.valorDescontoTituloEmPorcentagem = 0
		this.valorDescontoJurosDoTituloEmPorcentagem = 0
		this.valorDescontoMultaDoTituloEmPorcentagem = 0
		this.calcularValorFaltante()
	}

	get calcularReducaoDeJuros() {
		if(this.titulo?.formaDePagamento !== 'CREDIARIO' && this.titulo?.formaDePagamento !== 'BOLETO') return formatarMoeda(0);

		const juros = Number(this.valorJurosSobreBaixa) || 0;

		if(this.tipoDeDesconto === 'porcentagem'){
			const porcentagem = this.valorDescontoJurosDoTituloEmPorcentagem / 100;
			const valorFinal = juros - (juros * porcentagem);

			return formatarMoeda(Math.max(0, valorFinal - Number(this.baixaDePagamento.valorJurosSobreBaixa)));
		}else{
			return formatarMoeda(Math.max(0,Number(this.valorJurosSobreBaixa) - Number(this.valorDeDescontoNosJuros) || 0));
		}
	}

	somarDiasCarencia(dataVencimento, diasCarencia) {
		const data = new Date(dataVencimento);
		data.setDate(data.getDate() + diasCarencia);
		return data.toISOString().split('T')[0];
	}

	get calcularReducaoDeMulta() {
		if(this.titulo?.formaDePagamento !== 'CREDIARIO' && this.titulo?.formaDePagamento !== 'BOLETO') return formatarMoeda(0);

		const multa = Number(this.valorDaMultaSobreBaixa) || 0;

		const diasDeCarencia = this.somarDiasCarencia(this.titulo.dataDeVencimento, this.titulo.diasDeCarencia)
		const primeiraBaixaDoTitulo = this.titulo.baixaDePagamento?.[0]

		if(primeiraBaixaDoTitulo && new Date(diasDeCarencia) > new Date(primeiraBaixaDoTitulo.dataHoraPagamento) && this.titulo.multa === 0){
			return formatarMoeda(0)
		}
		
		if(this.tipoDeDesconto === 'porcentagem'){
			const porcentagem = this.valorDescontoMultaDoTituloEmPorcentagem / 100;
			const valorFinal = multa - (multa * porcentagem);

			return formatarMoeda(Math.max(0, valorFinal - Number(this.baixaDePagamento.valorDaMultaSobreBaixa)));
		}else{
			return formatarMoeda(Math.max(0,Number(this.valorDaMultaSobreBaixa) - Number(this.valorDeDescontoNaMulta) || 0));
		}
	}

	get calcularReducaoDeTitulo() {
		const valorTituloFaltante = Number(this.valorFaltanteDoTitulo) + Number(this.baixaDePagamento.valorDesconto) || 0;
		const desconto = Number(this.valorDescontoTituloEmPorcentagem) || 0;
		
		if(this.tipoDeDesconto === 'porcentagem'){
			const porcentagem = desconto / 100;

			// Sem descontar o pagamento aqui. Este getter alimenta o "Saldo Total" da tela E o
			// valorAtualizado enviado ao backend, e o backend usa esse número como saldo de
			// PARTIDA, subtraindo pagamento e perdão por conta própria. Descontar aqui fazia o
			// saldo chegar lá já projetado e ser descontado duas vezes: num título de 500,00 com
			// 300,00 pagos e 17,10 de encargos perdoados, o backend chegava a 200 - 300 - 17,10,
			// clampava em zero e marcava o título como PAGO com 200,00 ainda em aberto. Pior, como
			// o saldo zerou, o recálculo que corrigiria isso é pulado (ele só roda com saldo > 0),
			// então o erro ficava gravado.
			//
			// O ramo de valor fixado abaixo nunca subtraiu, e é justamente por isso que ele
			// sempre funcionou. Os dois passam a informar a mesma coisa.
			return formatarMoeda(Math.max(0, valorTituloFaltante - (valorTituloFaltante * porcentagem)));
		}else{
			return formatarMoeda(Math.max(0,Number(this.valorFaltanteDoTitulo)));
		}
	}

	/**
	 * Sobra do valor recebido depois de alocar multa, juros e principal.
	 *
	 * Medir pelo saldo restante não funciona: no desconto em porcentagem os getters de
	 * redução já abatem o que foi alocado, então o saldo cai a zero e o valor digitado
	 * inteiro aparecia como troco. Aqui a conta é direta, o recebido menos o distribuído.
	 */
	get troco(): number {
		const recebido = Number(this.baixaDePagamento.valorTotalTitulo || 0)
		const distribuido = Number(this.baixaDePagamento.valorPagamento || 0)
			+ Number(this.baixaDePagamento.valorJurosSobreBaixa || 0)
			+ Number(this.baixaDePagamento.valorDaMultaSobreBaixa || 0)

		return Math.max(0, Number((recebido - distribuido).toFixed(2)))
	}

	get calcularReducaoDeTituloCompleto(){
		return Math.max(0,  Number(this.calcularReducaoDeJuros.replace(/\./g, '').replace(',', '.')) +
						Number(this.calcularReducaoDeMulta.replace(/\./g, '').replace(',', '.')) +
						Number(this.calcularReducaoDeTitulo.replace(/\./g, '').replace(',', '.')))
	}

	get acrescimo(): number {
		if (this.fluxo === 'Entrada') return 0
		const valorPago = Number(this.baixaDePagamento.valorPagamento || 0)
		const valorFaltante = Number(this.valorFaltante || 0)
		return Math.max(0, Number((valorPago - valorFaltante).toFixed(2)))
	}

}
